import { requestBaseURL } from '@/config/api';

export type AppEnv =
  | 'dev'
  | 'testing'
  | 'staging1'
  | 'staging2'
  | 'prod1'
  | 'prod2'
  | 'unknown';

const ENV_MAP: Record<string, AppEnv> = {
  'http://localhost:18300': 'dev',
  'https://api.tlc-testing.benaimed.com': 'testing',
  'https://api.tlc-staging.benaimed.com': 'staging1',
  'https://api.tlc-staging-v2.benaimed.com': 'staging2',
  'https://api.tlc.benaimed.com': 'prod1',
  'https://api.tlc-v2.benaimed.com': 'prod2',
};

export function getAppEnv(): AppEnv {
  return ENV_MAP[requestBaseURL] ?? 'unknown';
}

export function isProdEnv(): boolean {
  const env = getAppEnv();
  return env === 'prod1' || env === 'prod2';
}
